import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

export const humanizeText = createAsyncThunk(
    'humanizer/humanizeText',
    async ({ text, persona, bypassMode }, { rejectWithValue }) => {
        try {
            const response = await apiCall('/humanize-text', 'POST', { text, persona, bypassMode });
            if (response.error) {
                return rejectWithValue(response.message || response.error);
            }
            return response;
        } catch (error) {
            return rejectWithValue('Error humanizing text');
        }
    }
);

const humanizerSlice = createSlice({
    name: 'humanizer',
    initialState: {
        humanizedText: null,
        originalLength: 0,
        humanizedLength: 0,
        personaUsed: 'default',
        loading: false,
        error: null,
        note: null,
    },
    reducers: {
        clearHumanizer: (state) => {
            state.humanizedText = null;
            state.originalLength = 0;
            state.humanizedLength = 0;
            state.personaUsed = 'default';
            state.error = null;
            state.note = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(humanizeText.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(humanizeText.fulfilled, (state, action) => {
                state.loading = false;
                state.humanizedText = action.payload.humanized_text;
                state.originalLength = action.payload.original_length;
                state.humanizedLength = action.payload.humanized_length;
                state.personaUsed = action.payload.persona_used;
                state.note = action.payload.note || null;
            })
            .addCase(humanizeText.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An unexpected error occurred';
            });
    },
});

export const { clearHumanizer } = humanizerSlice.actions;
export default humanizerSlice.reducer;
